import React from "react";
import logoSuperDucha from "../../../../assets/images/logo-super-ducha-white.png";
import { restartInteraction } from "../../../../stores/WashingStore/WashingStore";
import { FinishButton, TextContainer } from "./FailedActivationStyles";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
  Subtitle,
} from "../../TotemWashingStyles";

const FailedActivation: React.FC = () => {
  const handleRestart = () => {
    restartInteraction();
  };

  return (
    <GradientContainer>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Subtitle fontSize={"2.25rem"}>Falha ao finalizar processo</Subtitle>
        <Subtitle fontSize={"2.25rem"}>
          Exiba esta tela para um atendente
        </Subtitle>
        <FinishButton onClick={handleRestart}>Sair</FinishButton>
      </TextContainer>
    </GradientContainer>
  );
};

export default FailedActivation;
